module.exports = __webpack_public_path__ + "img/ertiga-xl7-negro-cosmos.33cb50f6.png";